














































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { types } from '../../api_types';
import T from '../../lang';
import user_Username from './Username.vue';
import * as ui from '../../ui';
import { getBlogUrl } from '../../urlHelper';
@Component({
  components: {
    'omegaup-user-username': user_Username,
  },
})
export default class UserBasicInfo extends Vue {
  @Prop() profile!: types.UserProfile;
  @Prop() rank!: string;
  T = T;
  ui = ui;

  get CategoriesFeatureGuideURL(): string {
    return getBlogUrl('CategoriesFeatureGuideURL');
  }

  get urlUsername(): string {
    return `https://omegaup.com/profile/${this.profile.username}/`;
  }

  get graduationDate(): string {
    if (!this.profile.graduation_date) {
      return '';
    }
    return this.profile.graduation_date.toLocaleDateString(T.locale);
  }
}
